import { useEffect, useState } from 'react';
import { API_BASE_URL } from '@/lib/apiBase';

// The backend is the only authority. Missing/unreachable config means OFF.
export function useLearnEnabled() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/features`, { cache: 'no-store' });
        const config = response.ok ? await response.json() : {};
        if (active) setEnabled(config.kalamanch_learn_enabled === true);
      } catch (_) {
        if (active) setEnabled(false);
      }
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    return () => { active = false; clearInterval(timer); };
  }, []);
  return enabled;
}

export function LearnPaused() {
  return <main className="mx-auto max-w-3xl px-6 py-24 text-center" role="status">
    <h1 className="text-3xl font-bold">Kalamanch Learn is temporarily unavailable</h1>
    <p className="mt-4">Your courses and progress are preserved. Please check back later.</p>
    <a className="mt-6 inline-block underline" href="https://www.kalamanch.art/">Visit KalaManch</a>
  </main>;
}
